import { Eye, FileArchive, FileSpreadsheet, FileText, LockKeyhole } from "lucide-react";
import { resources } from "../data";

const resourceGroups = Array.from(
  resources.reduce((groups, resource) => {
    const group = groups.get(resource.category) ?? [];
    group.push(resource);
    groups.set(resource.category, group);
    return groups;
  }, new Map<string, typeof resources>()),
);

function ResourceIcon({ type }: { type: string }) {
  if (type === "XLSX") return <FileSpreadsheet size={18} />;
  if (type === "ZIP") return <FileArchive size={18} />;
  return <FileText size={18} />;
}

function viewHref(href: string) {
  return `/view${href}`;
}

export default function ResourceLibrary() {
  return (
    <section id="resources" className="section resource-section">
      <div className="section-heading">
        <div>
          <span className="section-index">04</span>
          <h2>Resources and Library</h2>
        </div>
        <p>Program dossiers, one-page logical frameworks, workbooks and institutional files are available for protected preview. Downloads are locked in the current review phase.</p>
      </div>

      <div className="resource-groups">
        {resourceGroups.map(([category, group]) => (
          <div className="resource-group" key={category}>
            <h3>{category}</h3>
            <div className="resource-grid">
              {group.map((resource) => (
                <article key={resource.href} className="resource-row">
                  <div className="resource-type">
                    <ResourceIcon type={resource.type} />
                    <span>{resource.type}</span>
                  </div>
                  <div>
                    <a className="resource-title-link" href={viewHref(resource.href)}>
                      <strong>{resource.title}</strong>
                    </a>
                    <p>{resource.detail}</p>
                  </div>
                  <div className="resource-actions">
                    <a href={viewHref(resource.href)} aria-label={`View ${resource.title}`}>
                      <Eye size={17} />
                      <span>View</span>
                    </a>
                    <span className="resource-locked"><LockKeyhole size={14} /> Download locked</span>
                  </div>
                </article>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
